<template>
    <div class="header">
        <mu-appbar style="width: 100%;" color="primary">
            <mu-button icon slot="left" @click="back">
                <mu-icon value="chevron_left" size="24" color="#fff" @click="back" v-if="isShowBack"></mu-icon>
            </mu-button>

            <div class="nav-title" style="text-align:center;" @click="jumpIndex">
                <span style="font-size:14px;" >Take away</span>
        
            </div>

            <mu-menu slot="right" style="margin-right:10px;margin-top:16px;" class="notranslate">
                    <mu-button fab small color="success" style="position:absolute;right:45px;" @click="openSelectLngDialog">
                        {{selectLan}}
                    </mu-button>

                    <mu-button fab small color="indigo" @click="openDrawer">
                        <mu-icon value="person"></mu-icon>
                    </mu-button>
</mu-menu>
        </mu-appbar>
        <mu-dialog :title="$t('header.selectLanguage')" width="360" scrollable :open.sync="openLng">
            <mu-list>
                <mu-list-item :key="option" v-for="option in lngOptions">
                    <mu-list-item-content>
                        <mu-radio :label="option" :value="option" v-model="selectLan"></mu-radio>
                    </mu-list-item-content>
                </mu-list-item>
            </mu-list>
            <mu-button slot="actions" flat color="primary" @click="closeSelectLngDialog">{{$t('common.ok')}}</mu-button>
        </mu-dialog>
        <mu-drawer :open.sync="open" :docked="docked" :right="true" width="100%">
            <div style="font-size: 20px; font-weight: 500;text-align: center;margin-top: 5px; ">{{$t('header.info')}}</div>
            <mu-icon value="close" size="20" class="close-icon" @click="closeInfo"></mu-icon>
            <mu-form :model="tableOrderInfo" class="mu-demo-form" label-position="top" style="width:90%;margin:0 auto;margin-top:10px;">
                <mu-form-item prop="Name" :label="$t('login.name')" style="margin-bottom:0px;">
                    <mu-text-field v-model="tableOrderInfo.name"></mu-text-field>
                </mu-form-item>
                <mu-form-item :label="$t('login.telephone')" prop="Telephone" style="margin-bottom:0px;">
                    <mu-text-field v-model="tableOrderInfo.telephone" prop="Telephone"></mu-text-field>
                </mu-form-item>
            </mu-form>
            <div style="padding:20px;">
            <mu-sub-header style="font-size: 16px;text-align: center;font-weight: bold;">{{$t('orderList.orderList')}}</mu-sub-header>
            <mu-divider></mu-divider>
            <mu-list style="line-height: 28px;" v-for="item, index in orderList" :key="index">
                                <a @click="orderShow(item.orderId)">
                                    <div class="clearfix">
                                        <div class="fl">
                                           <span>No.{{ item.orderNo }}</span> 
                                         <p>{{ item.orderDay }}</p>
                                        </div>
                                         <div class="fr"><span>{{ item.actualAmount }} {{ seller.unit }}</span><p><em>&gt;</em></p></div></div></a>
                                         <mu-divider></mu-divider>
            
                </mu-list>
            </div>
    
        </mu-drawer>
    </div>
</template>

<script>
    export default {
        props: {
        },
        data() {
            return {
                seller: {},
                docked: false,
                open: false,
                isShowBack: true,
                detailShow: false,
                curBusinessHours: '',
                tableOrderInfo: {},
                openLng: false,
                selectLan:"EN",
                lngOptions: [
                    'DK',
                    'EN',
                    'PT',
                    '中文',
                ],
                orderList:[],
            }
        },
        methods: {
            getLanage() {
                if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                    this.$i18n.locale = localStorage.getItem('lang');
                    this.selectLan = localStorage.getItem('lang');
                    return localStorage.getItem('lang');
                }
                this.$i18n.locale = this.seller.language;
                return this.seller.language;
            },
            getOrderMainListByTelephone() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName,
                    telephone: this.tableOrderInfo.telephone
                };
                this.$get('QRCodeOrder/GetOrderMainListByTelephone', param)
                    .then(response => {
                        if (response.code == 200) {
                            if(response.data!=null && response.data!=''){
                                this.orderList = response.data;
                            }
                            else{
                                this.orderList = [];
                            }
                        } else {
                            this.orderList =[];
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            openSelectLngDialog() {
                this.getOrderMainListByTelephone();
                this.openLng = true;
            },
            closeSelectLngDialog() {
                this.$i18n.locale = this.selectLan;
                localStorage.setItem('lang', this.selectLan);
                this.openLng = false;
            
            },
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
            closeInfo() {
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
                this.open = false;
            },
            showDetail() {
                this.detailShow = true
            },
            hideDetail() {
                this.detailShow = false
            },
      
            jumpIndex() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/takeaway'
                })
            },
            orderShow(orderId){
                this.open=false;
                this.$router.push({
                    path: '/takeawayOrderList', query: {orderId:orderId}
                   },()=>{},()=>{});
            },
            back() {
                if (this.$route.path == '/restaurant') {
                    this.$router.push({
                        path: '/takeaway'
                    });
                }
                else if (this.$route.path == '/orderList') {
                    this.$router.push({
                        path: '/takeaway'
                    });
                }
                else if (this.$route.path == '/cartList') {
                    this.$confirm(this.$t("header.continueText"), this.$t("header.confirmTips"), {
                        type: 'info',
                        okLabel: this.$t("common.ok"),
                        cancelLabel: this.$t("common.cancel")
                    }).then(({ result }) => {
                        if (result) {
                            this.$router.go(-1);
                        }
                    })
                }
                else {
                    this.$router.go(-1);
                }
            },
            getPath() {
                if (this.$route.path == '/takeawayOrderList') {
                    console.log(123);
                    this.getOrderMainListByTelephone();
                }
            },
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.getLanage();
            this.getOrderMainListByTelephone();
            if (this.$route.path == '/takeaway') {
                    this.isShowBack = false;
                }
                else {
                    this.isShowBack = true;
                }
        },
        watch: {
           '$route': 'getPath'
        },
        components: {

        },

    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .header {
        overflow: hidden;
        position: relative;
        color: #fff;
        background-color: #FAFAFA;
        height: 56px;
    }

        .header .header-tip {
            width: 30px;
            position: absolute;
            top: 10px;
        }

        .header .header-search {
            width: 30px;
            position: absolute;
            top: 10px;
            left: 75%;
        }

        .header .header-cart {
            width: 30px;
            position: absolute;
            top: 10px;
            left: 87%;
        }

    .headerDivider {
        border-left: 1px solid #fff;
        height: 20px;
        position: absolute;
        top: 20px;
        padding-left: 5px;
        padding-right: 5px;
    }

    .shop {
        background: #fff;
        border-radius: 10px 10px 10px 10px;
        top: 50px;
        width: 94%;
        margin: 0 auto;
        position: absolute;
        display: block;
        left: 3%;
        z-index: 0;
        opacity: 0;
    }

    .flex-h {
        -webkit-box-orient: horizontal;
        -webkit-flex-flow: row;
        flex-flow: row;
    }

    .shop-header {
        padding: 10px 15px 0;
    }

    .ellipsis-1 {
        display: -webkit-box;
        white-space: normal !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .flex-1 {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
    }

    .shop-name {
        font-size: 16px;
        font-weight: 500;
        color: #616161;
    }

    .content-wrap {
        padding: 10px 15px;
    }

    .shop-address {
        width: 80%;
    }

    .shop-text {
        color: #666;
        font-size: 12px;
    }

    .shop-operation {
        border-top: 1px solid #eee;
    }

    .content-wrap {
        padding: 10px 15px;
    }

    .close-icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .link-btn {
        position: absolute;
        width: 100%;
        top: 20px;
        max-height: 100%;
        overflow: hidden;
        max-width: 100%;
        z-index: 999999;
        text-align: center;
    }

    h4.title {
        font-size: 18px;
        font-weight: normal;
        margin-bottom: 0;
        margin-top: 0;
        color: #fff;
        text-align:center;
    }

   .project-description {
        font-size: 13px;
        color: rgba(255,255,255,0.8);
        margin-top: 10px;
        margin-bottom: 15px;
    }
    .clearfix {
        zoom: 1;
        width:100%
    }
    .clearfix p {
        color: #b8b8b8;
    }
    .clearfix span {
        color: #333;
        text-decoration: none;
    }
    .fl {
        float: left;
    }
    .fl, .fr {
        display: inline;
    }
    .fr {
        float: right;
        text-align: right;
    }
    .clearfix .fl {
        width: 80%;
    }

</style>



// WEBPACK FOOTER //
// src/components/TakeawayHeader.vue